import { IconBuildingStore, IconFileDollar, IconHistory, IconPlugConnected, IconUsers } from "@tabler/icons-react";
import { type ComponentType, createElement, lazy, Suspense } from "react";

import { CAPS } from "@/shell/roles";

import type { FeatureRoute, NavItem } from "../types";

const pages = () => import("./PortalPages");
const IntegrationPage = lazy(() => pages().then((m) => ({ default: m.IntegrationPage })));
const BrandsPage = lazy(() => pages().then((m) => ({ default: m.BrandsPage })));
const UsersPage = lazy(() => pages().then((m) => ({ default: m.UsersPage })));
const ActivityPage = lazy(() => pages().then((m) => ({ default: m.ActivityPage })));
const TermsPage = lazy(() => pages().then((m) => ({ default: m.TermsPage })));
const BrandGamesPage = lazy(() => import("../games/BrandGamesGrid").then((m) => ({ default: m.BrandGamesPage })));

const el = <P extends object>(c: ComponentType<P>, props: P) =>
  createElement(Suspense, { fallback: null }, createElement(c, props));

export const routes: FeatureRoute[] = [
  { path: "/portal/integration", roles: CAPS.portal.integration, element: el(IntegrationPage, {}) },
  { path: "/portal/brands", roles: CAPS.portal.brandsRead, element: el(BrandsPage, {}) },
  {
    path: "/portal/brands/:brandId/games",
    roles: CAPS.portal.brandsRead,
    element: el(BrandGamesPage, { surface: "portal" }),
  },
  { path: "/portal/finance/terms", roles: CAPS.portal.terms, element: el(TermsPage, {}) },
  { path: "/portal/users", roles: CAPS.portal.users, element: el(UsersPage, {}) },
  { path: "/portal/activity", roles: CAPS.portal.activity, element: el(ActivityPage, {}) },
];

export const nav: NavItem[] = [
  {
    label: "Integration",
    path: "/portal/integration",
    icon: IconPlugConnected,
    surface: "portal",
    roles: CAPS.portal.integration,
  },
  {
    label: "Brands & games",
    path: "/portal/brands",
    icon: IconBuildingStore,
    surface: "portal",
    roles: CAPS.portal.brandsRead,
  },
  {
    label: "Commercial terms",
    path: "/portal/finance/terms",
    icon: IconFileDollar,
    surface: "portal",
    roles: CAPS.portal.terms,
  },
  { label: "Users", path: "/portal/users", icon: IconUsers, surface: "portal", roles: CAPS.portal.users },
  { label: "Activity", path: "/portal/activity", icon: IconHistory, surface: "portal", roles: CAPS.portal.activity },
];
